import React from "react";
import { IPackageDetailsItinerary } from "../interface/IPackageDetails.interface";
import RichText from "@/utils/richText";

interface IOverview {
  overview: IPackageDetailsItinerary[];
}

const Overview = ({ overview }: IOverview) => {
  if (!overview || overview.length === 0) return null;

  return (
    <section className="relative flex flex-col px-4 md:px-0">
      <div
        className="absolute left-[23px] md:left-[23px] top-10 bottom-10 w-[2px] bg-gray-100 hidden md:block"
        aria-hidden="true"
      />

      {overview.map((dayItem, index) => (
        <article
          key={dayItem?.id || index}
          className="relative flex flex-col items-center md:flex-row gap-6 md:gap-16 pb-12 group last:pb-0 cursor-pointer"
        >
          <div className="relative z-10 flex-shrink-0">
            <div className="bg-primary-700 text-white w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg shadow-gray-100 group-hover:bg-primary-600 transition-all duration-300 transform group-hover:scale-105">
              <div className="flex flex-col items-center leading-none">
                <span className="text-[10px] uppercase font-black opacity-70 tracking-tighter">
                  Day
                </span>
                <span className="text-lg font-bold">{dayItem?.day}</span>
              </div>
            </div>
          </div>

          <div className="flex-1">
            <div className="flex flex-col gap-3">
              <h3 className="text-xl font-black text-gray-900 uppercase tracking-tight leading-snug group-hover:text-primary-700 transition-colors">
                {dayItem?.title}
              </h3>

              {/* <RichText
                content={dayItem.description || ""}
                className="text-gray-600 leading-relaxed text-sm md:text-base prose prose-sm max-w-none 
                [&>p]:mb-4 [&>ul]:list-disc [&>ul]:pl-5 [&>ol]:list-decimal [&>ol]:pl-5
                [&>ul]:mb-4 [&>ol]:mb-4 last:[&>p]:mb-0"
              /> */}
            </div>

            {index !== overview.length - 1 && (
              <div
                className="w-full border-b border-gray-100 mt-8 md:hidden"
                aria-hidden="true"
              />
            )}
          </div>
        </article>
      ))}
    </section>
  );
};

export default Overview;
